"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const antd_1 = require("antd");
const antd_mask_input_1 = __importDefault(require("antd-mask-input"));
const Form_1 = require("antd/lib/form/Form");
const react_1 = __importDefault(require("react"));
const data_repository_1 = require("../../../../../dataSource/data_repository");
const detectDevice_1 = __importDefault(require("../../../../../utils/detectDevice"));
const notification_1 = require("../../../../../utils/notification");
require("./FormStyles.scss");
const Formulario = () => {
    const { isMobile } = (0, detectDevice_1.default)(900);
    const [form] = (0, Form_1.useForm)();
    function sendInformations() {
        const params = {
            name: form.getFieldValue('name'),
            email: form.getFieldValue('email'),
            telephone: form.getFieldValue('telephone').replace(/\D/g, ''),
            apartment: form.getFieldValue('apartment'),
            furnished: form.getFieldValue('furnished') === 'yes',
            notes: form.getFieldValue('comments'),
        };
        (0, data_repository_1.createOwner)(params)
            .then(response => {
            if (!response.isError) {
                (0, notification_1.NotificationSucessElementForm)();
            }
            else {
                (0, notification_1.NotificationWarningElement)();
            }
        })
            .catch(err => {
            (0, notification_1.NotificationErrorElement)();
        });
    }
    return (react_1.default.createElement(antd_1.Form, { form: form },
        react_1.default.createElement("div", { className: "Form" },
            react_1.default.createElement("div", { className: "left-content" },
                isMobile ? (react_1.default.createElement("span", { className: "form-title" },
                    "D\u00EA adeus \u00E0s",
                    react_1.default.createElement("span", null, "burocracias"))) : (react_1.default.createElement("span", { className: "form-title" }, "Entre em contato e d\u00EA adeus \u00E0s burocracias ")),
                react_1.default.createElement("span", { className: "form-subtitle" }, "Cuidamos de tudo para que voc\u00EA cuide do que realmente importa para voc\u00EA."),
                react_1.default.createElement("div", { className: "form-items" },
                    react_1.default.createElement("div", null,
                        react_1.default.createElement(antd_1.Form.Item, { className: "formClass", name: "name", rules: [
                                {
                                    required: true,
                                    validator(_, value) {
                                        if (value.length >= 3) {
                                            return Promise.resolve();
                                        }
                                        return Promise.reject(new Error('A campo deve ter mais de 3 caracteres!'));
                                    },
                                },
                            ] },
                            react_1.default.createElement("input", { placeholder: "Nome completo", type: "text" })),
                        react_1.default.createElement(antd_1.Form.Item, { className: "formClass", name: "telephone" },
                            react_1.default.createElement(antd_mask_input_1.default, { type: "tel", id: "masked-input", mask: "(11) 11111-1111", placeholder: "(XX) XXXXX-XXXX", className: "masked-input" }))),
                    react_1.default.createElement("div", null,
                        react_1.default.createElement(antd_1.Form.Item, { className: "formClass", rules: [{ type: 'email', message: 'Não é um formato de email válido!' }], name: "email" },
                            react_1.default.createElement("input", { placeholder: "Email", type: "text" }))),
                    react_1.default.createElement("div", null,
                        react_1.default.createElement(antd_1.Form.Item, { rules: [
                                {
                                    required: true,
                                    validator(_, value) {
                                        if (value.length >= 10 && value.length < 25) {
                                            return Promise.resolve();
                                        }
                                        return Promise.reject(new Error('O campo deve conter entre 10 a 25 caracteres!'));
                                    },
                                },
                            ], className: "formClass", name: "apartment" },
                            react_1.default.createElement("input", { placeholder: "Qual empreendimento voc\u00EA tem apartamento?", type: "text" }))),
                    react_1.default.createElement("div", { className: "radio-styled-group" },
                        react_1.default.createElement("span", null, "Seu apartamento est\u00E1 mobiliado?"),
                        react_1.default.createElement(antd_1.Form.Item, { className: "formClass", name: "furnished" },
                            react_1.default.createElement(antd_1.Radio.Group, null,
                                react_1.default.createElement(antd_1.Radio, { value: "yes" }, "Sim"),
                                react_1.default.createElement(antd_1.Radio, { value: "not" }, "N\u00E3o")))),
                    react_1.default.createElement("div", null,
                        react_1.default.createElement(antd_1.Form.Item, { className: "formClass", name: "comments", rules: [
                                {
                                    required: true,
                                    validator(_, value) {
                                        if (value.length < 50) {
                                            return Promise.resolve();
                                        }
                                        return Promise.reject(new Error('A campo deve ter no maximo 50 caracteres!'));
                                    },
                                },
                            ] },
                            react_1.default.createElement("input", { placeholder: "Observa\u00E7\u00E3o", type: "text" }))),
                    react_1.default.createElement(antd_1.Button, { onClick: sendInformations, className: "styled-button" }, "Enviar"))))));
};
exports.default = Formulario;
